import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Career from './pages/Career';
import About from './pages/About';
import Contact from './pages/Contact';
import CourseDetails from './pages/CourseDetails';
import TechForge from './pages/TechForge';
import RecruTech from './pages/RecruTech';
import ChocoCraft from './pages/ChocoCraft';
import KlyzenPawtner from './pages/KlyzenPawtner';
import KlyzenProductions from './pages/KlyzenProduction';
import PricingTable from './pages/PricingTable';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/services' element={<Services/>}  />
        <Route path='/pricingtable' element={<PricingTable/>}/>
        <Route path='/career' element={<Career/>} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/courses/:id" element={<CourseDetails />} />
        <Route path="/techforge" element={<TechForge />} />
        <Route path="/recrutech" element={<RecruTech />} />
        <Route path="/chococraft" element={<ChocoCraft />} />
        <Route path="/klyzenpawtner" element={<KlyzenPawtner />} />
        <Route path="/klyzenproduction" element={<KlyzenProductions />} />

      </Routes>
    </Router>
  );
}

export default App;
